import { render } from "./client_department.vue?vue&type=template&id=8561f1c0&scoped=true"
import script from "./client_department.vue?vue&type=script&lang=js"
export * from "./client_department.vue?vue&type=script&lang=js"

import "./client_department.vue?vue&type=style&index=0&id=8561f1c0&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8561f1c0"]])

export default __exports__